import React from 'react'
import Hero from '../Components/Hero'
import Services from '../Components/Services'

function Home() {
  return (
    <div>
        <Hero />
        <Services />
    </div>
  )
}

export default Home